import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { StorageService } from '@Shared/services';
import { AppSettings } from '@Shared/app.settings';

@Injectable({ providedIn: 'root' })
class AuthenticationGuard {
  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY)) {
      return true;
    }
    if (!!route.queryParams.businessId) {
      this.router
        .navigate([''], {
          queryParams: {
            type: 'sign-in',
            serviceUrl: `${state.url}`
          }
        })
        .then();
    } else if (route.queryParams.fromApp === 'true') {
      this.router
        .navigate([''], {
          queryParams: {
            type: 'sign-in',
            serviceUrl: `${state.url}`
          }
        })
        .then();
    } else {
      const redirectUrl = this.router.url.split('?')[0];
      if (redirectUrl === '/jobs' || redirectUrl === '/') {
        this.router.navigate([redirectUrl], {
          queryParams: {
            type: 'sign-up',
            serviceUrl: `${state.url}`
          }
        });
      } else {
        if (redirectUrl === '/jobs' || redirectUrl === '/') {
          this.router.navigate([redirectUrl], {
            queryParams: {
              type: 'sign-up',
              serviceUrl: `${state.url}`
            }
          });
        } else {
          this.router
            .navigate(['/'], {
              queryParams: {
                type: 'sign-up',
                serviceUrl: `${state.url}`
              }
            })
            .then();
        }
      }
    }
    return false;
  }
}

export const AuthenticationValidationGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthenticationGuard).canActivate(next, state);
};
